// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3F4ER","header":"MessagesList_header__1oA6z","chat":"MessagesList_chat__2Thdh"};